class FetchFacilityTemplateOverrides {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchFacilityTemplateOverrides;
